import { Module } from '@nestjs/common';
import { AuthService } from './auth.service';
import { AuthController } from './auth.controller';
import { PassportModule} from '../passport/passport.module';
import {JwtModule} from '@nestjs/jwt';
import {JwtStrategy} from './jwt.strategy'
import {UserModule} from '../user/user.module';
import { LogsModule } from '../logs/logs.module';
import { BotService } from '../bot/bot.service';
require('dotenv').config();
@Module({
  imports:[ 
    UserModule,
    LogsModule,
    PassportModule.register({      
    defaultStrategy: 'jwt',      
    property: 'user',      
    session: false,    
  }),
  JwtModule.register({
    secret: 'ramakrishna',//process.env.SECRETKEY, 
    signOptions: {
        expiresIn: '1h',//process.env.EXPIRESIN,
    },
  }),
  ],
  providers: [AuthService,JwtStrategy,BotService],
  controllers: [AuthController]
})
export class AuthModule {}
